import { render, staticRenderFns } from "./MyMulti.vue?vue&type=template&id=9709d630&"
import script from "./MyMulti.vue?vue&type=script&setup=true&lang=js&"
export * from "./MyMulti.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Multiselect.scss?vue&type=style&index=0&prod&lang=scss&"
import style1 from "./MyMulti.scss?vue&type=style&index=1&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports